var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "ui-bstooltip",
      attrs: {
        "data-placement": _vm.placement,
        "data-original-title": _vm.title
      }
    },
    [
      _vm.$slots.default
        ? [_vm._t("default")]
        : _c("span", [_vm._v("\n        " + _vm._s(_vm.more) + "\n    ")])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }